exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.page-not-found[data-v-0aff6e58]{text-align:center\n}\n.page-not-found h2[data-v-0aff6e58]{font-size:2rem\n}\n.page-not-found p[data-v-0aff6e58]{font-size:1.4rem\n}", "", {"version":3,"sources":["/var/lib/jenkins/workspace/tms-docker-build/frontend/shipper/src/components/modules/error/404.vue"],"names":[],"mappings":";AACA,iCAAiC,iBAAiB;CACjD;AACD,oCAAoC,cAAc;CACjD;AACD,mCAAmC,gBAAgB;CAClD","file":"404.vue","sourcesContent":["\n.page-not-found[data-v-0aff6e58]{text-align:center\n}\n.page-not-found h2[data-v-0aff6e58]{font-size:2rem\n}\n.page-not-found p[data-v-0aff6e58]{font-size:1.4rem\n}"],"sourceRoot":""}]);

// exports
